import React from "react";
import { usePageMeta } from "@/components/site/usePageMeta";
import { PageHero } from "@/components/site/PageHero";
import { SectionHeading } from "@/components/site/ui";
import { FinancingSection } from "@/components/site/FinancingSection";
import { MortgageCalculator } from "@/components/site/MortgageCalculator";
import { FaqSection } from "@/components/site/FaqSection";
import { LeadForm } from "@/components/site/LeadForm";
import { ContactSection } from "@/components/site/ContactSection";
import { ROUTES } from "@/components/site/data";

const IMG = "https://images.unsplash.com/photo-1635111300299-e6e677daf7b7?crop=entropy&cs=srgb&fm=jpg&q=85&w=1000";

export default function FinancingPage() {
  usePageMeta(
    "Financing | Wallstreet Realty",
    "Real estate and mortgage guidance in one place. Explore FHA, Conventional, VA, and Non-QM options and estimate your monthly payment with Wallstreet Realty."
  );
  return (
    <>
      <PageHero
        crumb="Financing"
        eyebrow="Real Estate + Mortgage"
        title="Guidance in One Place"
        subtitle="Buying is easier when your real estate and financing questions are part of the same conversation. Understand your next steps before you move forward."
        image={IMG}
        ctas={[
          { label: "Get Financing Guidance", href: "#financing-form", testid: "fin-hero-guidance" },
          { label: "Talk to a Buyer Agent", href: ROUTES.buy, variant: "outline", testid: "fin-hero-agent" },
        ]}
      />
      <FinancingSection />
      <MortgageCalculator />
      <section id="financing-form" className="py-16 lg:py-24 bg-white scroll-mt-[70px]">
        <div className="max-w-3xl mx-auto px-4 sm:px-6 lg:px-8">
          <SectionHeading
            eyebrow="Get Started"
            title="Request Financing Guidance"
            subtitle="Share a few details and we'll help you understand your options."
            center
          />
          <div className="mt-10">
            <LeadForm variant="financing" testid="financing-form" />
          </div>
        </div>
      </section>
      <FaqSection />
      <ContactSection />
    </>
  );
}
